import * as yup from 'yup';

yup.setLocale({
	mixed: {
		required: 'error.required', // Translation key goes here
		notType: 'error.required',
	},
	string: {
		required: 'error.required',
		email: 'error.correctEmail',
	},
	number: {
		required: 'error.required',
	},
	boolean: {
		isValue: 'error.required',
	},
});

export const CreateEventSchema = yup.object().shape({
	type: yup.string().required(),

	title: yup.string().required(),

	fromDate: yup.string().required(),

	toDate: yup.string().required(),
});
